import React from "react";
import FullWidthLayout from "../components/FullWidthLayout";
import WorkcellStatsGrid from '../components/WorkcellStatsGrid';
import { formatLocalDate } from "../utils/localDateTime";

const WorkcellLandingPage = () => {
  const date = formatLocalDate(new Date());
  // const date = "2024-10-01";
  return (
    <FullWidthLayout>
      <WorkcellStatsGrid date_param={date} />
    </FullWidthLayout>
  );
};

export default WorkcellLandingPage;
